import React, { useEffect, useState } from "react";
import "./App.css";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomeScreen from "./Component/Screens/HomeScreen/HomeScreen";
import LoginScreen from "./Component/Screens/Login/LoginScreen";
import ProfileScreen from "./Component/Screens/ProfileScreen/ProfileScreen";
import { useDispatch, useSelector } from "react-redux";
import { login, logout } from "./Component/features/UserSlice";
import { selectUser, selectLink } from "./Component/features/UserSlice";
import { Watch } from "./Component/Watch/Watch";

const App = () => {
  const user = useSelector(selectUser);
  const video = useSelector(selectLink);
 
  const dispatch = useDispatch();

  const auth = getAuth();
  useEffect(() => {
    const unSubscribe = onAuthStateChanged(auth, (userAuth) => {
      if (userAuth) {
        const userid = userAuth.uid;
        const useremail = userAuth.email;

        dispatch(
          login({
            uid: userid,
            email: useremail,
          })
        );
      } else {
        dispatch(logout);
      }
    });
    return unSubscribe;
  }, []);

  return (
    <div className="App">
      <Router>
        {video.key !== null ? <Watch /> : ""}
        {!user ? (
          <LoginScreen />
        ) : (
          <Routes>
            <Route path="/profile" element={<ProfileScreen />} />
            <Route path="/" element={<HomeScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/watch" element={<Watch />} />
          </Routes>
        )}
      </Router>
    </div>
  );
};

export default App;
